/* OTF Facelift — fluid-sub.js
   Bu Site's storefront add-ons. Small, additive, and deliberately NOT part of
   fluid-motion.js: that file is 106 KB minified and shared, and more than one
   agent edits this theme (fluid-bar.liquid was already clobbered once on
   1 Sep). fluid-rv-sheet.js attaches from the outside for the same reason.

   These live in ONE file on purpose: every one of them needs DELEGATED events,
   because the page sheets are injected with innerHTML and a <script> inside
   injected HTML never runs. Each block is inert unless its markup opts in.

     1. Subscriptions never open the quick sheet - ONLY once otf.weeks is set.
     2. The plan radios drive the hidden quantity and the block price.
     3. The business enquiry composes a WhatsApp message.
     4. A sheet can be given a short title instead of the whole link's text.
     5. In-sheet anchor scrolling.
     6. Focus management for the page sheets - which the theme does not have.
     7. A card that is also an anchor must not navigate when the sheet opens.
*/
(function () {
  'use strict';

  var NL = String.fromCharCode(10); /* a real newline. Written this way on
     purpose: this file is uploaded through a GraphQL block string, where a
     backslash passes through literally, and a "n" escape silently became two
     characters in the shipped asset - which WhatsApp then printed as text in
     the middle of the enquiry. Do not "tidy" this back. */

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  /* plain left-click, no modifier - the same test fluid-motion.js applies
     before it hijacks a link, so cmd/ctrl/middle-click still opens a tab. */
  function plainClick(e) {
    return !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button);
  }

  /* ------------------------------------------------------------------ 1
     Keep subscriptions out of the quick sheet - but ONLY once otf.weeks is set.
     The sheet re-fetches /products/<handle>.js and rebuilds its variant buttons
     and price from Shopify's own JSON, so once the product sells as quantity N
     of a WEEKLY unit it would quote the per-week price with a stepper starting
     at 1. That cannot be corrected from Liquid.
     While otf.weeks is empty - which is the case today - fluid-gcard does NOT
     emit data-sub, nothing here fires, and subscriptions open in the sheet like
     any other product, correctly, because every variant price is a real block
     price. CAPTURE PHASE is load-bearing: fluid-motion.js listens in the bubble
     phase, so stopping propagation on the way down is what prevents it. We do
     NOT preventDefault - the anchor must still navigate. */
  document.addEventListener('click', function (e) {
    if (closest(e.target, '.fluid-gcard[data-sub]')) e.stopPropagation();
  }, true);

  /* ------------------------------------------------------------------ 7
     The Weekly Flowers promo tile is an <a href> that also carries .fluid-gcard,
     so motion.js opens the quick sheet from it. motion.js does NOT preventDefault
     when it opens a sheet from a card - it never had to, because every other card
     is a <button> - so without this the tile would open the sheet AND navigate.
     Deliberately not merged into block 1: that one stops the sheet, this one
     stops the navigation, and a [data-sub] card wants the opposite of this.
     If this file never loads the tile just navigates, which is what it did
     before - it degrades to the old behaviour rather than to nothing.

     CAPTURE PHASE IS THE WHOLE FIX, AND IT IS NOT OPTIONAL (bug, 1 Sep: the
     tile opened the sheet and then span forever). fluid-motion.js carries a
     navigation loading marklet:

       document.addEventListener('click', function (e) {
         var a = e.target.closest('a[href]');
         ... if (!a || e.defaultPrevented || ...) return;
         ... href.indexOf('/pages/') === 0 || href.indexOf('/policies/') === 0
             || fluidLoad(true);
       });

     It shows the spinner for ANY internal link that is not /pages/ or
     /policies/, and the ONLY thing that ever hides it again is the pageshow
     event of the navigation it is waiting for. /products/weekly-flowers is
     such a link. Cancelling that navigation in the BUBBLE phase is too late:
     fluid-motion.js is loaded first, so its listener runs first, sees
     defaultPrevented === false, and arms a spinner for a page that will now
     never load. Cancelling in the CAPTURE phase sets defaultPrevented before
     that listener is ever reached, and it skips the spinner on its own.
     Do not move this back to the bubble phase. */
  document.addEventListener('click', function (e) {
    if (!plainClick(e)) return;
    var a = closest(e.target, 'a.fluid-gcard');
    if (!a || a.hasAttribute('data-sub')) return;
    e.preventDefault();
  }, true);

  /* ------------------------------------------------------------------ 4
     Remember which link opened a page sheet, so we can give the sheet a short
     title and hand focus back on close. The home business band is one big <a>,
     so fluid-motion's open(path, a.textContent) would title the sheet with the
     band's entire text. */
  var lastTrigger = null;
  document.addEventListener('click', function (e) {
    var a = closest(e.target, 'a[href^="/pages/"], a[href^="/policies/"]');
    if (a) lastTrigger = a;
  }, true);

  /* ------------------------------------------------------------------ 5
     In-sheet anchor scrolling. Inside a sheet the scroll container is
     [data-pgbody], not the window, so a bare hash jump is unreliable. The
     markup keeps a real href so it still works on a direct page load. */
  document.addEventListener('click', function (e) {
    var a = closest(e.target, '[data-bizscroll]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    try {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) {
      target.scrollIntoView();
    }
  });

  /* ------------------------------------------------------------------ 3
     The business enquiry. NOT a Shopify contact form: the business page opens
     as a sheet, and a posting form would navigate the window and tear the
     sheet down. This composes a WhatsApp message instead - the same thing the
     custom planner, the event planner and the cash gift all do.

     THE NO-FORM PATH LIVES HERE (CEO, 1 Sep). There is only one button, and it
     must still serve someone who wants to type nothing and just talk:
       - the heading line is ALWAYS included, so an empty form opens WhatsApp
         with a sensible one-line opener rather than a blank chat;
       - every empty field is skipped, so a partly filled form never sends a
         message full of blank labels. */
  document.addEventListener('click', function (e) {
    var go = closest(e.target, '[data-bizgo]');
    if (!go) return;
    var form = closest(go, '[data-bizform]');
    if (!form) return;

    function val(name) {
      var f = form.querySelector('[data-f="' + name + '"]');
      return f ? (f.value || '').trim() : '';
    }
    function label(name) {
      return form.getAttribute('data-l-' + name) || name;
    }

    var lines = [];
    var head = form.getAttribute('data-l-head');
    if (head) lines.push(head);

    ['name', 'biz', 'phone', 'type', 'look', 'msg'].forEach(function (f) {
      var v = val(f);
      if (v) lines.push(label(f) + ': ' + v);
    });

    var base = form.getAttribute('data-wa') || 'https://wa.me/96599548711';
    go.setAttribute('href', lines.length
      ? base + '?text=' + encodeURIComponent(lines.join(NL))
      : base);
    /* no preventDefault - the link opens with the href we just set */
  });

  /* ------------------------------------------------------------------ 6
     Focus management for the page sheets.
     fluid-motion.js gives them role="dialog", an aria-label, a back button,
     a scrim and Escape - but it does not move focus in, trap it, or hand it
     back. That gap affects EVERY page sheet on the site (Gifts, Care guide,
     Events, the policies), not only the business one, so this fixes it for all
     of them from the outside rather than editing the minified file. */
  var trapLayer = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), ' +
                  'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusables(root) {
    var all = root.querySelectorAll(FOCUSABLE), out = [], i;
    for (i = 0; i < all.length; i++) {
      if (all[i].offsetParent !== null || all[i] === document.activeElement) out.push(all[i]);
    }
    return out;
  }

  function onTrapKey(e) {
    if (e.key !== 'Tab' || !trapLayer) return;
    var list = focusables(trapLayer);
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    } else if (!trapLayer.contains(document.activeElement)) {
      e.preventDefault(); first.focus();
    }
  }

  function sheetOpened(layer) {
    if (lastTrigger) {
      var t = lastTrigger.getAttribute('data-sheet-title');
      if (t) {
        var tEl = layer.querySelector('[data-pgtitle]');
        if (tEl) tEl.textContent = t;
      }
    }
    trapLayer = layer;
    document.addEventListener('keydown', onTrapKey, true);
    var back = layer.querySelector('.fluid-oback');
    if (back) { try { back.focus(); } catch (err) {} }
  }

  function sheetClosed() {
    trapLayer = null;
    document.removeEventListener('keydown', onTrapKey, true);
    if (lastTrigger && document.contains(lastTrigger)) {
      try { lastTrigger.focus(); } catch (err) {}
    }
    lastTrigger = null;
  }

  if (window.MutationObserver && document.body) {
    new MutationObserver(function (muts) {
      var i, j, n;
      for (i = 0; i < muts.length; i++) {
        for (j = 0; j < muts[i].addedNodes.length; j++) {
          n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && n.classList && n.classList.contains('fluid-pgl')) sheetOpened(n);
        }
        for (j = 0; j < muts[i].removedNodes.length; j++) {
          n = muts[i].removedNodes[j];
          if (n.nodeType === 1 && n.classList && n.classList.contains('fluid-pgl')) sheetClosed();
        }
      }
    }).observe(document.body, { childList: true });
  }

  /* ------------------------------------------------------------------ 2
     The plan radios drive the quantity and the price. The radios are a native
     Shopify product form, so the add itself needs no JavaScript: with this
     file missing, the pre-checked plan still posts the right quantity. */
  function bindPlan() {
    var form = document.querySelector('[data-subform]');
    if (!form || form._subBound) return;
    form._subBound = true;

    var qtyInput = form.querySelector('[data-subqty]');
    var priceEl  = document.querySelector('[data-subprice]');
    var lineEl   = document.querySelector('[data-subline]');
    var pdpEl    = document.querySelector('.fluid-pdp');

    function sync() {
      var r = form.querySelector('input[name="id"]:checked');
      if (!r) return;
      var weeks = r.getAttribute('data-weeks');
      var block = r.getAttribute('data-block');
      var line  = r.getAttribute('data-line');
      var raw   = r.getAttribute('data-blockraw');
      if (qtyInput && weeks) qtyInput.value = weeks;
      if (priceEl && block) priceEl.textContent = block;
      if (lineEl && line) lineEl.textContent = line;
      if (pdpEl && raw) pdpEl.setAttribute('data-vraw', raw);
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') sync();
    });
    sync();
  }

  bindPlan();
})();